<template>
  <transition name="fade">
    <div class="exercise exercise-list exercise-tabs">
      <div class="ss-breadcrumb">
        <div class="container-hts">
          <ul class="margin-0 p-0">
            <li>
              <router-link to="/luyen-tap">Luyện tập</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="ss-banner ss-banner--shadow-img ss-banner--ebook ss-banner--not-bg" >
        <div class="container-hts">
          <div v-if="!isMobile" class="ss-banner__wrap display-flex-end justify-content-between">
            <div class="ss-banner__classes">
              <span class="ss-banner__classes__name">Lớp</span>
              <ul class="ss-banner__classes__list p-0 margin-0">
                <li v-for="(item, index) of classFilter" :key="`filter_${index}`">
                  <a
                    href="javascript:;"
                    class="height-100"
                    :class="{'active': item.classId == classActive}"
                    @click="filterExerciseByClass(item)"
                  >
                    <img
                      v-if="item.classId==classActive"
                      src="@/assets/images/bg-number.png"
                      :alt="item.classNo"
                    />
                    <span :class="{'mn':item.name == 'Mầm non'}">{{ formatName(item.name) }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <FilterMobile
            v-else-if="isMobile && classFilter && classFilter.length > 0 && dataTabs && dataTabs.length"
            :classes="classFilter"
            :selectClass="classActive"
            :bookGroups="dataTabs"
            @filterClass="filterExerciseByClass"
            @filterGroup="handleSetTabActive"
          />
        </div>
      </div>
      <div class="ss-data">
        <div class="container-hts">
          <b-tabs v-if="!isMobile" class="exercise-list__tabs tabs-tooltip justify-content-between">
            <b-tab v-for="(item, index) of dataTabs" :key="index" :active="tabActive == item.practiceTypeId ? true : false" class="exercise-list__tab" @click="handleSetTabActive(item, index)">
              <template v-slot:title>{{ item.name }}</template>
            </b-tab>
          </b-tabs>
          <div class="exercise-list__data">
            <div class="row mb-100">
              <ItemExam
                v-for="(item, index) of dataSubjects"
                :key="index"
                :dataSource="item"
                :tabPracticeTypeId="tabPracticeTypeId"
                :examTypes="item.practiceTypeNew"
                class="col-xl-3 col-md-4 col-sm-6"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { STORE_KEY, LOCAL_QUESTIONS_DATA, LOCAL_SAVE_CAT, TYPE_EXERCISE_OTHER, TYPE_EXERCISE_THEMATIC, TYPE_EXERCISE_EXAM } from "../_store/constants";
  import { mapState, mapActions } from "vuex";
  import { APP_CONFIG } from "@/utils/constants";
  import { classList } from "./../_api/";
  import { getlistExercise } from "./../_api/exercise-list";
  import ItemExam from './../_components/exam/ItemExam'
  import { ID_CLASS_1 } from '@/store/common/constants'
  import FilterMobile from './../_components/FilterMobile'

  export default {
    name: "ExerciseList",
    components: {
      ItemExam,
      FilterMobile
    },
    data() {
      return {
        cdnUrl: APP_CONFIG.cdnurl,
        appUrl: APP_CONFIG.appUrl,
        classActive: 0,
        subjectIdActive: 0,
        classFilter: [],
        subjects: [],
        tabActive: 0,
        isCreated: true,
        dataTabs: [],
        dataSubjects: [],
        dataTypesExam: [],
        windowWidth: 0,
        indexDataTabs: 0,
        tabPracticeTypeId: 3
      };
    },
    computed: {
      routerQuery() {
        return this.$route.query;
      },
      isMobile () {
        return this.windowWidth < 991 ? true : false;
      }
    },
    watch: {
      classActive: 'onChangeClassFilter'
    },
    created() {
      this.getClassListFilter();
    },
    mounted () {
      this.tabActive = this.routerQuery.tab
      this.$nextTick(function() {
        window.addEventListener('resize', this.getWindowWidth);
        //Init
        this.getWindowWidth()
      })
      localStorage.removeItem(LOCAL_QUESTIONS_DATA)
      localStorage.removeItem(LOCAL_SAVE_CAT)
    },
    methods: {

      getWindowWidth (event) {
        this.windowWidth = window.innerWidth
      },

      filterExerciseByClass (data) {
        if (this.classActive !== data.classId) {
          this.tabActive = 0
          this.classActive = data.classId
          // this.setReplaceRouter()
        }
        console.log(this.classActive)
      },
      formatName(name){
        if(name =='Mầm non'){
          return name
        }
        return name.substring(4)
      },
      handleSetTabActive (data, index) {
        this.indexDataTabs = index
        this.tabActive = data.practiceTypeId
        this.tabPracticeTypeId = data.practiceTypeId
        this.dataSubjects = this.dataTabs[index].practiceSujectNewModel
        this.setReplaceRouter()
      },

      async onChangeClassFilter() {
        let self = this
        // save classInfo
        // let indexClasses = self.classFilter.findIndex(cl => cl.classId === self.classActive)
        // this.tabActive = 0;
        await this.setReplaceRouter()
        this.fetchSubjectExams()
      },

      fetchSubjectExams () {
        this.classActive && getlistExercise(this.classActive).then(res => {
          if (res) {
            this.dataTabs = res
            // this.dataTypesExam = res.lstPracticeChildb
            // console.log('this.routerQuery.tab', this.routerQuery.tab);
            if (res && res.length > 0 && this.routerQuery.tab) {
              let indexPractice = res.findIndex(cl => cl.practiceTypeId === parseInt(this.routerQuery.tab))
              this.tabActive = indexPractice > -1 ? this.routerQuery.tab : res[0].practiceTypeId
              this.dataSubjects = res[indexPractice > -1 ? indexPractice : 0].practiceSujectNewModel
            } else if (res && res.length > 0 && !this.routerQuery.tab) {
              this.tabActive = res[0].practiceTypeId
              this.dataSubjects = res[0].practiceSujectNewModel
            }
            // this.setReplaceRouter()
          }
        })
      },

      getClassListFilter() {
        let self = this;
        classList().then(res => {
          if (res && res.data && res.data.classes && res.data.classes.length > 0 ) {
            self.classFilter = res.data.classes
            self.classActive = self.routerQuery.lop && self.routerQuery.lop > 0 ? parseInt(self.routerQuery.lop) : res.data.classes ? res.data.classes[0].classId : 0
          }
        }).finally()
      },

      setReplaceRouter() {
        if (!this.routerQuery || (this.routerQuery && (this.routerQuery.lop !== this.classActive || this.routerQuery.tab !== this.tabActive))) {
          this.$router.replace({query: {lop: this.classActive, tab: this.tabActive}})
          // this.tabActive = this.routerQuery.tab
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
.height-100{
  height: 100%;
}
  span.mn {
      font-size: 20px;
      position: absolute!important;
      right: 0;
  }
  .mb-100{
    margin-bottom: 100px;
  }
  .exercise-list {

    &__data {
      padding: 30px 0 10px;

      // .item {
      //   border: 1px solid red;
      //   width: calc(100% / 4)
      // }
    }
  }
  @media screen and ( max-width: 991px ) {
    .ss-data, .exercise-list__data {
      padding-top: 0;
    }
  }
</style>